import { i18n } from '@shared/util/i18n';
import { NestedOptionsRow } from '../NestedOptionsRow';

export function RelatedCardSortRow() {
  return (
    <NestedOptionsRow
      name={i18n('common.sort')}
      defaultIcon={'arrows-up-down-swap'}
      selectedIcon="chat-bubbles-square"
      enabled={true}
    />
  );
}
